import { useEffect, useState } from "react";
import authHeader from "services/auth-header";
import API from "services/axios";

// The actual values stored in quotes.status -- confirmed against the DB, not
// assumed. Add here if new ones are introduced.
const STATUS_OPTIONS = ["pending", "completed"];

export default function QuoteSearchFields({ formData, handleInputChange }) {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await API.get("/locations", { headers: authHeader() });
        if (!cancelled) setLocations(data || []);
      } catch {
        // A failed lookup just leaves the dropdown empty -- every other field
        // still works, so this shouldn't block the whole form.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const text = (name, label, type = "text") => (
    <div className="col-md-4 mb-2">
      <label className="form-label mb-1">{label}</label>
      <input
        type={type}
        name={name}
        className="form-control"
        value={formData?.[name] || ""}
        onChange={handleInputChange}
      />
    </div>
  );

  return (
    <div>
      <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2">
        Quote
      </h4>
      <div className="row bg-white custom-border-radius-sm custom-shadow mx-1 py-2">
        {text("quoteId", "Q-ID", "number")}
        {text("jobName", "Job Name")}
        {text("customerName", "Customer Name")}

        <div className="col-md-4 mb-2">
          <label className="form-label mb-1">Status</label>
          <select
            name="status"
            className="form-select"
            value={formData?.status || ""}
            onChange={handleInputChange}
          >
            <option value="">Any</option>
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label className="form-label mb-1">Location</label>
          <select
            name="locationId"
            className="form-select"
            value={formData?.locationId || ""}
            onChange={handleInputChange}
          >
            <option value="">Any</option>
            {/* -1 is the backend's "no location set" sentinel. */}
            <option value="-1">No Location</option>
            {locations?.map((loc) => (
              <option key={loc.id} value={loc.id}>
                {loc.locationName}
              </option>
            ))}
          </select>
        </div>

        {text("customerBidId", "Customer Bid ID")}
      </div>

      <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2 mt-3">
        Contact
      </h4>
      <div className="row bg-white custom-border-radius-sm custom-shadow mx-1 py-2">
        {text("contactFirstName", "First Name")}
        {text("contactLastName", "Last Name")}
        {text("contactEmail", "Email")}
        {text("contactPhone", "Phone")}
        {text("contactDepartment", "Department")}
      </div>

      <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2 mt-3">
        Bid Details
      </h4>
      <div className="row bg-white custom-border-radius-sm custom-shadow mx-1 py-2">
        {text("deliveryMethod", "Delivery Method")}
        {text("result", "Result")}
        {text("bidNotes", "Bid Notes")}
      </div>
    </div>
  );
}
